import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { selectAuthToken } from 'selectors';
import * as IntegrationService from 'IntegrationModule/services';
import type { AxiosResponse } from 'axios';
import { useNotification } from 'hooks/useNotification';

export const useUpdatePhaseOrderMutation = () => {
  const token = useSelector(selectAuthToken) as string | undefined;
  const { showSuccess, showError } = useNotification();

  const mutation = useMutation<AxiosResponse<any>, unknown, { targetServiceId: number }>({
    mutationFn: async ({ targetServiceId }) => {
      if (!token) throw new Error('Not Authenticated');
      return IntegrationService.updatePhaseOrder({ targetServiceId }, {}, token);
    },
    onSuccess: (response) => {
      if (response?.status === 201) {
        showSuccess('Retroactive Phase Order triggered successfully.');
      }
    },
    onError: () => {
      showError('Failed to trigger Retroactive Phase Order.');
    },
  });

  return {
    updatePhaseOrder: mutation.mutate,
    isUpdatingPhaseOrder: mutation.isPending,
  };
};

export default useUpdatePhaseOrderMutation;
